
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-lawyers",
      function () {
        return require("private-next-pages/for-lawyers.tsx");
      }
    ]);
  